import { gql } from '@apollo/client'
import { Button, Modal } from '@farol-ds/react'
import { ReactNode } from 'react'

import { useModalContext } from '../context'
import { LinkedAccountLockModalLock_OfferLockDataFragment } from './__generated__/modal-lock.graphql'
import styles from './linked-account-lock.module.scss'

interface ModalProps {
  isAIVariant?: boolean
  children: ReactNode
  offerLockData: LinkedAccountLockModalLock_OfferLockDataFragment
}

export function ModalLock({ offerLockData, children, isAIVariant = false }: ModalProps) {
  const { open, setOpen } = useModalContext()
  if (!offerLockData.body.cards.length) {
    return null
  }

  const handleOnclick = () => {
    setOpen(false)
  }

  const buttonLabel = offerLockData.body.cards[0].buttons[0].label

  return (
    <Modal open={open} onOpenChange={setOpen} size="sm">
      <Modal.Content>
        <Modal.IconClose />
        <Modal.Body className={styles.body}>{children}</Modal.Body>
        {!isAIVariant && (
          <Modal.Footer>
            <Button kind="primary" onClick={handleOnclick}>
              {buttonLabel}
            </Button>
          </Modal.Footer>
        )}
      </Modal.Content>
    </Modal>
  )
}

ModalLock.fragments = {
  offerLockData: gql`
    fragment LinkedAccountLockModalLock_offerLockData on OfferLockData {
      body {
        cards {
          buttons {
            label
          }
        }
      }
    }
  `,
}
